import React from 'react';
import styled from 'styled-components';
import Image from '@pedidosya/web-fenix/foundations/Image';
import { getLogo } from '@pedidosya/web-fenix/utils/image';

const Container = styled.div`
  margin-right: 48px;
`;

function HeaderLogo() {
  return (
    <Container>
      <Image alt="Logo de PedidosYa" src={getLogo('Logo_Text_PedidosYa')} />
    </Container>
  );
}

export default HeaderLogo;
